<template>
  <div>
    <div class="content-warp">
      <JoinFactory v-if="matchInfo.isPlayerRes === 1"></JoinFactory>
      <DefaultJoin v-else></DefaultJoin>
    </div>
  </div>
</template>
<script>
import store from '@/store'
import { mapState } from 'vuex'
import DefaultJoin from './DefaultJoin.vue'
import JoinFactory from './joinFactory/JoinFactory.vue'
export default {
  name: 'Join',
  components: {
    DefaultJoin,
    JoinFactory
  },
  mounted () {
    console.log(this.userInfo.remark === '北京学校账号')
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo,
    }),
  },
  data () {
    return {
      matchId: Number(this.$route.query.matchId),
      matchInfo: store.getters['match/matchInfo']
    }
  },
  methods: {
   
  }
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/comm/components/join/Join.vue